var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-primary",class:{ disabled: _vm.disabled, 'btn-loading': _vm.loading, 'btn-plain': _vm.plain },style:([
  {
    backgroundColor: _vm.plain ? 'transparent' : _vm.btnBackgroundColor,
    '--hover-background': _vm.plain ? 'transparent' : _vm.getHoverColor(_vm.btnBackgroundColor || '$color-button-primary'),
    '--hover-color': _vm.plain ? _vm.getHoverColor('#182058') : '#FFFFFF'
  },
  _vm.customStyle
]),attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.handleClick}},[(!_vm.loading)?[_vm._t("default")]:[_c('div',{staticStyle:{"width":"100%"}},[_vm._v(" "+_vm._s(_vm.$t('message.result.processing'))+" "),_c('i',{staticClass:"el-icon-loading"})])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }